import React from 'react';
import DesignOptionFilterForm from '../DesignOptionFilterForm';
import enhance from './enhance';

const ExteriorOptionFilters = ({
  options,
  exteriorFormPlaceHolder,
  setActiveFilters,
  activeFilters,
  clearFilter,
}) => {
  return (
    <DesignOptionFilterForm
      options={options}
      placeHolder={exteriorFormPlaceHolder}
      setActiveFilters={setActiveFilters}
      activeFilters={activeFilters}
      filterName="paintOption"
      clearFilter={clearFilter}
    />
  );
};

export default enhance(ExteriorOptionFilters);
